import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InputComponent} from "../input/input.component";
import {InputModel, WidthSizes} from "../input/models/input.model";

const defaultInputOptions: InputModel = {
  label: 'Page Quick Search',
  value: '',
  widthSize: WidthSizes.widthDefault,
  placeholder: ''
};

@Component({
  selector: 'app-quick-search',
  standalone: true,
  imports: [
    InputComponent
  ],
  templateUrl: './quick-search.component.html',
  styleUrl: './quick-search.component.scss'
})
export class QuickSearchComponent implements OnInit {
  private _options: InputModel = defaultInputOptions

  @Input() data: any[] = [];

  @Input() set options(value: InputModel) {
    this._options = {...defaultInputOptions, ...value};
  }

  get options(): InputModel {
    return this._options;
  }

  @Output() filteredDataChange = new EventEmitter<any[]>();

  ngOnInit() {
    this.filteredDataChange.emit(this.data);
  }


  onSearchValueChange(value: string): void {
    const filtered = this.filterData(value);
    this.filteredDataChange.emit(filtered);
  }

  private filterData(searchValue: string): any[] {
    if (!searchValue) {
      return this.data;
    }

    const lowerSearchValue = searchValue.toLowerCase();
    return this.data.filter(item => {
      return Object.values(item).some(value => {
        if (value === null || value === undefined) return false;
        return value.toString().toLowerCase().includes(lowerSearchValue);
      });
    });
  }
}

